import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';

export interface BottomCalloutProps {
  children: React.ReactNode;
  className?: string;
  icon?: IconDefinition;
}

export const BottomCallout: FC<BottomCalloutProps> = ({ 
  children, 
  className = '', 
  icon = faLightbulb
}) => {
  return (
    <div className={`bg-white rounded-lg p-4 shadow-lg mt-6 ${className}`}>
      <div className="flex items-start gap-3 justify-center">
        <div className="flex-shrink-0 mt-0.5">
          <FontAwesomeIcon icon={icon} className="w-5 h-5 text-primary" />
        </div>
        <p className="text-sm text-black leading-relaxed">{children}</p>
      </div>
    </div>
  );
}; 